<app-exams-list-card [pageData] = "pageData"></app-exams-list-card>